export default __webpack_public_path__ + "static/media/planetary.2c7cfb9e.png";